import { render } from "./TestAttachments.vue?vue&type=template&id=6d4b081c"
import script from "./TestAttachments.vue?vue&type=script&lang=js"
export * from "./TestAttachments.vue?vue&type=script&lang=js"

import "./TestAttachments.vue?vue&type=style&index=0&id=6d4b081c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/TestAttachments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d4b081c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d4b081c', __exports__)) {
    console.log('reload')
    api.reload('6d4b081c', __exports__)
  }
  
  module.hot.accept("./TestAttachments.vue?vue&type=template&id=6d4b081c", () => {
    console.log('re-render')
    api.rerender('6d4b081c', render)
  })

}


export default __exports__